import React from 'react';
import './NavBar.scss';
import {useAuth0} from "../../utils/providers/Auth0Provider";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";
import {navigate} from "@reach/router";
import AccountPreferencesModal from "./components/AccountPreferencesModal";
import {compose} from "redux";
import {connect} from "react-redux";
import Logo from "../../assets/Fidelius_Finalized_Logo_Parts-02.svg"
import LogoText from "../../assets/Fidelius_Finalized_Logo_Parts-01.svg"
import {toggleAccountPreferencesModal} from "../../redux/reducers/utils";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";


const NavBar = (props) => {
  const { isAuthenticated, logout, loginWithRedirect, loading } = useAuth0();
  const [accountPopper, setAccountPopper] = React.useState(null);
  const [sidebarDrawerOpen, setSidebarDrawerOpen] = React.useState(false);
  const [helpPopper, setHelpPopper] = React.useState(null);


  const handleClose = () => {
    props.toggleAccountPreferencesModal(false);
    setAccountPopper(null);
    setHelpPopper(null);
  };

  const onLogout = () => {
    window.drift.reset();
    logout()
  };

  const openLiveChat = () => {
    window.driftApi.widget.show();
    window.driftApi.sidebar.open();
    setHelpPopper(null);
  };

  const openHelpEmail = () => {
    window.location = "mailto:support@fideliusvaults.com?Subject=Fidelius Help";
    setHelpPopper(null);
  };

  const sendDemoEmail = () => {
    window.location = "mailto:support@fideliusvaults.com?Subject=Fidelius Demo Request&body=Name:%0D%0A%0D%0APhone:%0D%0A%0D%0ATime Available:%0D%0A%0D%0A";
    setHelpPopper(null);
  }

  const toggleDrawer = (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setSidebarDrawerOpen(!sidebarDrawerOpen)
  };

  const getSidebarContent = () => {
    return <SwipeableDrawer
      open={sidebarDrawerOpen}
      anchor={'right'}
      onClose={toggleDrawer}
    >
      <div
        role="presentation"
        onClick={toggleDrawer}
        onKeyDown={toggleDrawer}
      >
        <List>
          {
            !loading && isAuthenticated && props.user &&
            <>
              <p className="text-2xl mb-2 sidebar-user-text text-ellipsis">{props.user.name}</p>
              <Divider/>
              <ListItem button onClick={() => props.toggleAccountPreferencesModal(true)}>
                <FontAwesomeIcon icon="user-cog" className="text-secondary mr-2"/>
                <ListItemText primary={'Account Details'} className="text-black"/>
              </ListItem>
              <ListItem button onClick={onLogout}>
                <FontAwesomeIcon icon="sign-out-alt" className="text-secondary mr-2"/>
                <ListItemText primary={'Logout'} />
              </ListItem>
              <div className="mb-4"/>
            </>
          }
          <p className="text-grey text-sm">Resources</p>
          <Divider/>
          <ListItem button component="a" href={"https://www.fideliusvaults.com/pricing/"} target="_blank">
            <FontAwesomeIcon icon="users" className="text-secondary mr-2"/>
            <ListItemText primary={'Pricing'} className="text-black"/>
          </ListItem>
          <ListItem button component="a" href={"https://www.fideliusvaults.com/how-it-works/"} target="_blank">
            <FontAwesomeIcon icon="list" className="text-secondary mr-2"/>
            <ListItemText primary={'How It Works'} className="text-black"/>
          </ListItem>
          <ListItem button component="a" href={"https://www.fideliusvaults.com/faq/"} target="_blank">
            <FontAwesomeIcon icon="question-circle" className="text-secondary mr-2"/>
            <ListItemText primary={'FAQ'} className="text-black"/>
          </ListItem>
          <p className="text-grey text-sm mt-4">Contact Us</p>
          <Divider/>
          <ListItem button component="a" href={"mailto:support@fideliusvaults.com?Subject=Fidelius Help"} target="_blank">
            <FontAwesomeIcon icon="envelope" className="text-secondary mr-2"/>
            <ListItemText primary={'Email'} className="text-black"/>
          </ListItem>
          <ListItem button onClick={openLiveChat}>
            <FontAwesomeIcon icon="comments" className="text-secondary mr-2"/>
            <ListItemText primary={'Live Chat'} className="text-black"/>
          </ListItem>
        </List>
        <div className="mt-4">
          <Button
            variant="outlined"
            color="primary"
            onClick={()=>sendDemoEmail()}
            className="w-full"
          > Request a Demo
          </Button>
        </div>
      </div>
    </SwipeableDrawer>
  }
  return (
    <div className="nav-bar-container px-4 md:px-8">
      <div className="nav-bar-inner-container flex justify-between h-full items-center">
        <a className="flex items-center" onClick={() => navigate("/vaults")}>
          <img className={"logo-container mr-2"} src={Logo}/>
          <img className={"logo-text"} src={LogoText}/>
        </a>
        {
          !loading && (!isAuthenticated || props.user)&&
          <>
            <div className="lg:hidden">
              <Button onClick={toggleDrawer}>
                <FontAwesomeIcon icon="bars" size="lg" className="text-white"/>
              </Button>
            </div>
            <div className="h-full hidden lg:block">
              <div className="flex items-center h-full">
                {isAuthenticated &&
                <div className="mr-2 h-full">
                  <Button
                    className={"h-full"}
                    onClick={() => navigate(props.user.type === 'INDIVIDUAL' ? "/vaults" : '/clients')}>
                    <p className="text-white lg:text-lg">{props.user.type === 'INDIVIDUAL' ?'My Vaults' : 'My Clients'}</p>
                  </Button>
                </div>
                }
                {(!isAuthenticated || props.user.subscriptionType === 'FREE_TRIAL') &&
                <div className="mr-2 h-full">
                  <Button href={"https://www.fideliusvaults.com/pricing/"} target="_blank"
                          className={"h-full"}>
                    <p className="text-white lg:text-lg">Pricing</p>
                  </Button>
                </div>
                }
                <div className="mr-2 h-full">
                  <Button
                    className={"h-full"}
                    onClick={(event) => setHelpPopper(event.currentTarget)}>
                    <div className="text-white flex items-center">
                      <p className="lg:text-lg">Resources</p>
                      <FontAwesomeIcon icon="caret-down" className="ml-2"/>
                    </div>
                  </Button>
                </div>
                {isAuthenticated &&
                <Button
                  className={"h-full"}
                  onClick={(event) => setAccountPopper(event.currentTarget)}>
                  <div className="text-white flex items-center">
                    <FontAwesomeIcon icon="user-tie" className="mr-2"/>
                    <p className="lg:text-lg">{props.user.name}</p>
                    <FontAwesomeIcon icon="caret-down" className="ml-2"/>
                  </div>
                </Button>
                }
                {!isAuthenticated && (
                  <Button
                    className={"h-full"}
                    onClick={() => loginWithRedirect({})}>
                    <div className="text-white flex items-center h-full">
                      <FontAwesomeIcon icon="sign-in-alt" className="mr-2"/>
                      <p className="lg:text-lg">Login</p>
                    </div>
                  </Button>
                )}
              </div>
            </div>
          </>
        }
      </div>

      {/*sidebar*/}
      {getSidebarContent()}

      {/* Popper components */}
      <Popover
        open={!!helpPopper}
        anchorEl={helpPopper}
        onClose={handleClose}
        className={""}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div>
          <Button className="nav-popper-button text-black" onClick={handleClose} target="_blank" href={"https://www.fideliusvaults.com/how-it-works/"}>
            <div className="flex items-center my-1">
              <FontAwesomeIcon icon="list" className="text-secondary mr-3"/>
              <p className='capitalize text-lg text-black'>How It Works</p>
            </div>
          </Button>
        </div>
        <Divider/>
        <div>
          <Button className="nav-popper-button text-black" onClick={handleClose} target="_blank" href={"https://www.fideliusvaults.com/faq/"}>
            <div className="flex items-center my-1">
              <FontAwesomeIcon icon="question-circle" className="text-secondary mr-3"/>
              <p className="text-lg text-black">FAQ</p>
            </div>
          </Button>
        </div>
        <Divider/>
        <div>
          <Button className="nav-popper-button" onClick={handleClose} onClick={openHelpEmail}>
            <div className="flex items-center my-1">
              <FontAwesomeIcon icon="envelope" className="text-secondary mr-3"/>
              <p className='capitalize text-lg '>Contact Us</p>
            </div>
          </Button>
        </div>
        <Divider/>
        <div>
          <Button className="nav-popper-button" onClick={handleClose} onClick={openLiveChat}>
            <div className="flex items-center my-1">
              <FontAwesomeIcon icon="comments" className="text-secondary mr-3"/>
              <p className='capitalize text-lg '>Live Chat</p>
            </div>
          </Button>
        </div>
      </Popover>
      <Popover
        open={!!accountPopper}
        anchorEl={accountPopper}
        onClose={handleClose}
        className={"account-popper"}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div>
          <Button className="nav-popper-button" onClick={() => props.toggleAccountPreferencesModal(true)}>
            <div className="flex items-center my-1">
              <FontAwesomeIcon icon="user-cog" className="text-secondary mr-3"/>
              <p className='capitalize text-lg '>Account Details</p>
            </div>
          </Button>
        </div>
        <Divider/>
        <div>
          <Button onClick={onLogout} className="nav-popper-button">
            <div className="flex items-center my-1">
              <FontAwesomeIcon icon="sign-out-alt" className="text-secondary mr-3"/>
              <p className='capitalize text-lg '>Logout</p>
            </div>
          </Button>
        </div>
      </Popover>
      <AccountPreferencesModal open={props.openAccountPreferences} onClose={handleClose}/>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
    openAccountPreferences: state.utils.openAccountPreferences,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleAccountPreferencesModal }
  )
)(NavBar);